import progress from './progress/index.js';
import goalSetting from './goal-setting/index.js';
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../../hooks/enabled-module-guard";
import PatientOverviewSmoking from 'dashboard/templates/views/Patient/SC/PatientOverviewSmoking';

const navigationSteps = {
  prevDiscussionStep: {
    PatientRecordSmokingProgress: 'PatientRecordProgress',
    PatientRecordSmokingGoalSetting: 'PatientRecordSmokingProgress',
  },
  nextDiscussionStep: {
    PatientRecordSmokingProgress: 'PatientRecordSmokingGoalSetting',
    PatientRecordSmokingGoalSetting: 'PatientRecordProgress',
  },
}

export default {
  component: PatientOverviewSmoking,
  path: 'smoking-relief',
  name: 'PatientRecordSmoking',
  props: navigationSteps,
  redirect: { name: 'PatientRecordSmokingProgress' },
  meta: {
    // title: 'Patient Record Smoking Relief', TODO
    title: t => `${t('patient.patientRecord')} - ${t('smokingReliefLevel3.dailyPresence.beneficialMindfulness.task1.smokingRelief', 'content')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    goalSetting,
  ],
  async beforeEnter(to, from, next) {
    // If user was redirected from page because Smoking management is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["SMOKECESSATION"], to, next)){
      return
    }

    next();
  },
};
